import React from "react";
import { useNavigate } from "react-router-dom";
import FlatwareIcon from "@mui/icons-material/Flatware";
import DirectionsBusIcon from "@mui/icons-material/DirectionsBus";
import FlightIcon from "@mui/icons-material/Flight";
import HotelIcon from "@mui/icons-material/Hotel";
import { format } from "date-fns";
import formatCurrency from "../../helpers/formatCurrency";

const PackageCard = ({ pkg }) => {
  const navigate = useNavigate();

  const formatDateRange = () => {
    const start = new Date(pkg.travelPeriod.startDate.seconds * 1000);
    const end = new Date(pkg.travelPeriod.endDate.seconds * 1000);
    return `${format(start, "MMM d, yyyy")} - ${format(end, "MMM d, yyyy")}`;
  };

  const handleClick = () => {
    navigate(`/package/${pkg.id}`);
  };

  return (
    <div className="priced-card shadow-sm" onClick={handleClick}>
		<div
			className="img-part"
			style={{ backgroundImage: `url(${pkg.images[0]})` }}
		>
			<div className="icons-container">
				{pkg.inclusions.Flights && (
					<span>
						<FlightIcon fontSize="xsmall" />
					</span>
				)}
				{pkg.inclusions.Transfer && (
					<span>
						<DirectionsBusIcon fontSize="xsmall" />
					</span>
				)}
				{pkg.inclusions.Food && (
					<span>
						<FlatwareIcon fontSize="xsmall" />
					</span>
				)}
				{pkg.inclusions.Accommodation && (
					<span>
						<HotelIcon fontSize="xsmall" />
					</span>
				)}
			</div>
		</div>
		<div className="text-part">
			<span className="days"><span className='days'>{pkg.duration} days / {pkg.duration - 1} nights</span></span>
			<h4 className="location">{pkg.title}</h4>
			<span className="dates">{formatDateRange()}</span>
			<p className="short-desc">{pkg.experience.join(", ")}</p>
		</div>
		<h2 className="price">
			<span className="from">From</span>{formatCurrency(pkg.price)}
			<span className="pps">pps</span>
		</h2>
    </div>
  );
};

export default PackageCard;
